// The seller's agreement to the application on a SecureMyOffer policy converted from a certificate
// (PBI 24307). PolicyApp records it from the storefront, where the seller agrees by email, and an
// administrator can record one given another way, by phone say: the one action below writes it.

/** The PolicyApp action an administrator records or takes back the seller's agreement with. */
export const RECORD_SELLER_AGREEMENT = 'RecordSellerAgreement';

/** Statuses on which nothing is recorded any more. */
const CLOSED_STATUSES = new Set(['cancelled', 'lost']);

/** Whether the seller has agreed: the declaration accepted and the date it was given, both. */
export const sellerHasAgreed = (secureMyOfferCustomInfo) =>
    secureMyOfferCustomInfo?.applicationDeclarationAccepted === true &&
    Boolean(secureMyOfferCustomInfo?.sellerAgreedOn);

/** Whether the policy is one whose seller agrees: converted from a certificate, and still open. */
export const asksTheSeller = (policy) =>
    policy?.secureMyOfferCustomInfo?.isConvertedFromCertificate === true && !CLOSED_STATUSES.has(policy?.status);

/** Only an administrator records it, at any open status: the policy may otherwise be read-only. */
export const mayRecordSellerAgreement = (policy, userType) =>
    asksTheSeller(policy) && userType?.toLowerCase() === 'administrator';

/** The Agree email PolicyApp sent the seller, by its template code. */
export const AGREE_EMAIL_LABEL_IDS = {
    SecureMyOffer_SellerAgreeConfirmAndPay: 'Profile_SecureMyOffer_SellerAgreement.agreeEmail.confirmAndPay',
    SecureMyOffer_SellerAgreePaidSeparately: 'Profile_SecureMyOffer_SellerAgreement.agreeEmail.paidSeparately',
    SecureMyOffer_SellerAgreeAlreadyPaid: 'Profile_SecureMyOffer_SellerAgreement.agreeEmail.alreadyPaid',
};
